export const isUserAuthenticated = (status: string) => {
  return status === 'authenticated'
}
